(function () {
	const logoSlideshow = () => {
		$(".logo-slideshow-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".logo-slideshow");
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			} else {
				autoplayParm = {};
			}
			let swiperParms = {
				parallax: true,
				speed: box.data("speed") * 1000,
				loop: true,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				...autoplayParm,
			};
			const swiper = new Swiper(`#${id} .logo-slideshow__swiper`, swiperParms);
			colorScheme(swiper);
			swiper.on("beforeTransitionStart", function () {
				colorScheme(this);
			});
			function colorScheme(context) {
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				const changeItems = [
					context.navigation.nextEl,
					context.navigation.prevEl,
					context.pagination.el,
				];
				const colorScheme = $(activeSlide)
					.find(".logo-slideshow-slide")
					.data("color-scheme");
				changeItems.forEach((item) => {
					$(item)
						.removeClass("color-background-1")
						.removeClass("color-background-4")
						.addClass(colorScheme);
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		logoSlideshow();
		document.addEventListener("shopify:section:load", function () {
			logoSlideshow();
		});
	});
})();
(function () {
  const overlay = document.querySelector(".falling-stars-overlay");
  if (!overlay) return;

  const STAR_VARIANTS = 3;

  function spawnStar() {
    const star = document.createElement("div");

    // elijo variante 1, 2 o 3
    const variant = Math.floor(Math.random() * STAR_VARIANTS) + 1;
    star.className = `falling-star falling-star--${variant}`;

    // posición horizontal
    star.style.left = Math.random() * 100 + "vw";

    // tamaño 10–20px
    const size = 10 + Math.random() * 10;
    star.style.width = size + "px";
    star.style.height = size + "px";

    // rotación fija aleatoria
    const initialRotation = Math.random() * 360;
    star.style.transform = `rotate(${initialRotation}deg)`;

    // duración de caída 4–8s
    const fallDuration = 4 + Math.random() * 4;
    star.style.animationDuration = `${fallDuration}s`;

    overlay.appendChild(star);

    // limpieza
    setTimeout(() => star.remove(), fallDuration * 1000 + 200);
  }

  // Una estrella nueva cada 150ms
  setInterval(spawnStar, 150);
})();

